//
// BaseModel.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";
import "../properties/PropertyOwner";

var BaseModel = createModule("commons::BaseModel", ["commons::PropertyOwner"], EventDispatcher, [
    {
        BASE_MODEL_PARSER_ERROR: 10001,
        UNRESOLVED_ENTITY: 10002,
    },
    ,
    ,
    ,
    ,
    ,
    ,
]);
export default BaseModel;
